import { render, staticRenderFns } from "./CTag.vue?vue&type=template&id=2eb96cf0&"
import script from "./CTag.vue?vue&type=script&lang=js&"
export * from "./CTag.vue?vue&type=script&lang=js&"
import style0 from "./CTag.vue?vue&type=style&index=0&id=2eb96cf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports